import React, { useState } from "react";
import "./Achievements.css";

function Achievements() {
  const [modalImg, setModalImg] = useState(null);
  return (
    <section id="achievements" className="achievements">
      <h2 className="section-title">Achievements & Memberships</h2>
      <div className="achievements-list">

        {/* INC 5000 */}
        <div className="achievement-row">
          <div className="achievement-text">
            <h3 className="achievement-title">INC 5000</h3>
            <p>
              Wright Brothers Contracting Services, Inc. was recognized in the INC 5000 list of fastest-growing private companies in America, ranking #1423 overall in 2023, #63 in its industry, and #143 in the state of Florida, with an impressive 409% growth rate. This achievement highlights the company’s strong performance, consistent expansion, and commitment to excellence within the construction industry.
            </p>
          </div>
          <div className="achievement-image">
            <img src="/Images/Achievements/INC5000.jpg" alt="INC 5000" onClick={() => setModalImg("/Images/Achievements/INC5000.jpg")}/>
          </div>
        </div>

        {/* AGC Membership */}
        <div className="achievement-row">
          <div className="achievement-text">
            <h3 className="achievement-title">AGC Membership</h3>
            <p>
              Wright Brothers Contracting Services, Inc. is a proud member of the Associated General Contractors of America (AGC), Florida East Coast Chapter, upholding the core values of Skill, Integrity, and Responsibility while promoting fair and honorable practices across the construction industry.
            </p>
          </div>
          <div className="achievement-image">
            <img src="/Images/Achievements/AGC.jpeg" alt="AGC Membership" onClick={() => setModalImg("/Images/Achievements/AGC.jpeg")}/>
          </div>
        </div>

        
        {/* <div className="achievement-row">
          <div className="achievement-text">
            <h3 className="achievement-title">ABC Membership</h3>
            <p>
              Proud member of the Associated Builders and Contractors (ABC).
            </p>
          </div>
          <div className="achievement-image">
            <img src="/Images/Achievements/AGC.jpeg" alt="ABC Membership" onClick={() => setModalImg("/Images/Achievements/AGC.jpeg")}/>
          </div>
        </div> */}

        

      </div>

      {modalImg && (
        <div className="achievement-modal" onClick={() => setModalImg(null)}>
          <div className="achievement-modal-content" onClick={e => e.stopPropagation()}>
            <img src={modalImg} alt="Achievement Large" />
            <button className="achievement-modal-close" onClick={() => setModalImg(null)}>&times;</button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Achievements;
